import type { FamilyId } from '../experiments/family-zoo';

export const FAMILY_PRESETS: Record<FamilyId, Record<string, number>> = {
  linear: { m: 1, b: 0 },
  quadratic: { a: 1, b: 0, c: 0 },
  cubic: { a: 1, b: 0, c: 0, d: 0 },
  polynomial: { c0: 0, c1: 0, c2: 1, c3: 0, c4: 0, c5: 0, c6: 0 },
  rational: { numA: 1, numB: 0, denA: 1, denB: -2 },
  exponential: { a: 1, b: Math.E, c: 0 },
  logarithmic: { a: 1, b: 10, c: 0 },
  'absolute-value': { a: 1, h: 0, k: 0 },
  'square-root': { a: 1, h: 0, k: 0 },
  sin: {},
  cos: {},
  tan: {},
};
